import { API_URL } from "../config";
import { Descripcion } from "../types/Descripcion";
import { EspecialidadesResponse } from "../types/EspecialidadesResponse";

interface RawEspecialidadData {
  esta_actualizado: number;
  descripcion: string;
  subespecialidades: Array<{
    uuid: string;
    especialidad: string;
    descripcion: string[];
    esta_actualizado: number;
  }>;
}

export const especialidadesServices = {
  getEspecialidades: async (): Promise<EspecialidadesResponse> => {
    try {
      const response = await fetch(`${API_URL}/especialidades`);
      if (!response.ok) {
        throw new Error("Error al obtener los datos de las especialidades");
      }
      const data = (await response.json()) as Record<
        string,
        RawEspecialidadData
      >;

      // Mapear el campo uuid a uuid_especialidad
      const mappedData = Object.entries(data).reduce(
        (acc, [categoria, categoriaData]) => {
          acc[categoria] = {
            ...categoriaData,
            esta_actualizado: categoriaData.esta_actualizado,
            subespecialidades: categoriaData.subespecialidades.map((sub) => ({
              ...sub,
              uuid_especialidad: sub.uuid,
              descripcion: sub.descripcion || [],
              esta_actualizado: sub.esta_actualizado,
            })),
          };
          return acc;
        },
        {} as EspecialidadesResponse
      );

      return mappedData;
    } catch (error) {
      console.error("Error al obtener los datos de las especialidades:", error);
      throw error;
    }
  },

  // Descripcion de una subespecialidad
  addDescripcion: async (descripcion: Descripcion): Promise<void> => {
    try {
      const response = await fetch(
        `${API_URL}/especialidades/subespecialidades/${descripcion.uuid_especialidad}/descripciones`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            descripcion: descripcion.descripcion,
            esta_actualizado: 0,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Error al agregar la descripción");
      }
    } catch (error) {
      console.error("Error al agregar la descripción:", error);
      throw error;
    }
  },

  deleteDescripcion: async (
    uuid_descripcion: string,
    indice: number,
    esta_actualizado: number
  ): Promise<void> => {
    try {
      const response = await fetch(
        `${API_URL}/especialidades/subespecialidades/${uuid_descripcion}/descripciones/${indice}?esta_actualizado=${esta_actualizado}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error al eliminar la descripcion");
      }
    } catch (error) {
      console.error("Error al eliminar la descripcion:", error);
      throw error;
    }
  },

  editDescripcion: async (
    uuid_especialidad: string,
    indice: number,
    descripcion: string,
    esta_actualizado: number
  ): Promise<void> => {
    try {
      const response = await fetch(
        `${API_URL}/especialidades/subespecialidades/${uuid_especialidad}/descripciones/${indice}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            descripcion: descripcion,
            esta_actualizado: esta_actualizado,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Error al editar la descripción");
      }
    } catch (error) {
      console.error("Error al editar la descripción:", error);
      throw error;
    }
  },
};
